import { html, property } from 'lit-element';
import { nothing } from 'lit-html';
import { KatLitElement, register } from '../../shared/base';
import baseStyles from '../../shared/base/base.lit.scss';
import styles from './kpi-bar.lit.scss';

/**
 * @component {kat-kpi-bar} KatKpiBar The KPI Bar allows for the display of a few key data points along with a limited visualization for each point. This module makes it easier to summarize and provide insight into the status of the page.
 * @status Production
 * @theme flo
 * @slot default Should be filled with `kpi-bar-item` elements.
 * @slot kpi-bar-utility-actions Utility section for KPI filters actions
 * @subcomponent ./kpi-bar-item.ts
 * @example Default {"header": "Sample KPI Bar"}
 */
@register('kat-kpi-bar')
export class KatKpiBar extends KatLitElement {
  static get styles() {
    return [baseStyles, styles];
  }

  /** Header for KPI bar. */
  @property()
  header: string;

  /** Sub header for KPI bar. */
  @property()
  subheader?: string;

  renderSubHeader() {
    return html`
      ${!this.subheader
        ? nothing
        : html`<div class="sub-header">${this.subheader}</div>`}
    `;
  }

  render() {
    return html`
      <div class="header">
        <h2>${this.header}</h2>
      </div>
      ${this.renderSubHeader()}
      <div class="utility-actions">
        <slot name="kpi-bar-utility-actions"></slot>
      </div>
      <div class="bar-items">
        <slot></slot>
      </div>
    `;
  }
}
